import * as t from "io-ts";
import type { ReplayData } from "../../types/ReplayData";

const finiteNumber = t.refinement(t.number, Number.isFinite);
const positionSchema = t.type({ time: finiteNumber, x: finiteNumber, y: finiteNumber, z: finiteNumber });
const rotationSchema = t.type({ time: finiteNumber, angle: finiteNumber });
const characterSchema = t.intersection([
  t.type({
    id: t.string,
    name: t.string,
    team: finiteNumber,
    jerseyNumber: finiteNumber,
    isPlayer: t.boolean,
    position: t.array(positionSchema),
    rotation: t.array(rotationSchema),
  }),
  t.partial({ lookFrames: t.array(positionSchema) }),
]);

export const ReplayDataSchema = t.intersection([
  t.type({ duration: finiteNumber, characters: t.array(characterSchema) }),
  t.partial({
    ball: t.type({ position: t.array(positionSchema), rotation: t.array(rotationSchema) }),
    events: t.array(t.unknown),
  }),
]);

export const parseReplayData = (value: unknown): ReplayData | null => {
  if (!ReplayDataSchema.is(value)) return null;
  return { ...value, characters: value.characters.map(character => ({ ...character, lookFrames: character.lookFrames ?? [] })) };
};
